import * as React from 'react';

import type { IInformationContext } from './information.context.types';

const InformationContext = React.createContext<IInformationContext | undefined>(void 0);

InformationContext.displayName = 'context(Information)';

export default InformationContext;